import mapFromRaceData from './raceDataMapper';
import PositionsCache from '../PositionsCache';

export function mapFromDataRaceToRace(dataRacedata, dataRaceResults) {
    return buildRaceAndPositions(dataRacedata, dataRaceResults);
}

function buildRaceAndPositions(dataRacedata, dataRaceResults) {
    return {
        ...mapFromRaceData(dataRacedata),
        trackSegments: dataRaceResults.MSR.map(currentSR => {
            return {
                name: currentSR.SN
            };
        }),
        sessionId: dataRaceResults.A,
        sessionName: dataRaceResults.S,
        totalTrackSegments: dataRaceResults.SC,
        dateTime: dataRaceResults.DT,
        holeShot: dataRaceResults.HS,
        positions: buildPositions(dataRaceResults),
        
    }
}

function buildPositions(dataRaceResults) {
    if (!dataRaceResults || !Array.isArray(dataRaceResults.B)) {
        return [];
    }

    const positions = dataRaceResults.B.map(dataRacePosition => ({
        race: {
            position: dataRacePosition.A,
            gap: dataRacePosition.G,
            diff: dataRacePosition.D,
            lapsCompleted: dataRacePosition.L,
            lastLapTime: dataRacePosition.LL,
            bestLapTime: dataRacePosition.BL,
            bestLap: dataRacePosition.IN,
            raceMarker: dataRacePosition.RM,
            bestLapTimeInSeconds: timeToSeconds(dataRacePosition.BL),
            track: {
                lastSegmentCompleted: dataRacePosition.LS,
                segments: dataRacePosition.SR.map(track => ({
                    name: track.SN,
                    time: track.ST,
                    timeIndicator: track.MST,
                    improvedLastTime: track.RM === 4,
                    increasedLastTime: PositionsCache.getIncreasedLastTime(dataRacePosition.I, track.SN),
                }))
            },
        },
        rider: {
            id: dataRacePosition.I,
            name: dataRacePosition.F,
            number: dataRacePosition.N,
            vehicle: {
                name: dataRacePosition.V,
                brand: dataRacePosition.V.split(' ')[0].toLowerCase()
            },
            status: dataRacePosition.S,
            hometown: dataRacePosition.H,
            team: dataRacePosition.T
        },
    }));

    // Filter out positions with invalid or zero lap times before determining the overall best lap time
    const validPositions = positions.filter(position => position.race.bestLapTimeInSeconds !== null);
    const overallBestLapTime = validPositions.length > 0
        ? validPositions.reduce((min, p) => Math.min(min, p.race.bestLapTimeInSeconds), Infinity)
        : null;

    // Add the isBestOverallLap flag, considering only valid and non-zero lap times
    return positions.map(position => ({
        ...position,
        race: {
            ...position.race,
            isBestOverallLap: position.race.bestLapTimeInSeconds === overallBestLapTime,
        },
    }));
}

function timeToSeconds(time) {
    // Check for invalid time formats or all zeros
    if (!time || time.includes("--") || time === "0" || time.includes("00.000") || time === "0.000" || parseFloat(time) === 0) {
        return null; // Indicate invalid or missing time with null
    }

    const parts = time.split(':');
    if (parts.length === 2) {
        const minutes = parseInt(parts[0], 10);
        const seconds = parseFloat(parts[1]);
        return minutes * 60 + seconds;
    }
    return parseFloat(time);
}
